export { default as OrderingDoctorListTemplate } from './OrderingDoctorListTemplate';
